import { render } from "./generarpedido.vue?vue&type=template&id=404cb6c7&scoped=true"
import script from "./generarpedido.vue?vue&type=script&lang=js"
export * from "./generarpedido.vue?vue&type=script&lang=js"

import "./generarpedido.vue?vue&type=style&index=0&id=404cb6c7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404cb6c7"]])

export default __exports__